'use strict';

const submitCartForm = ev => {
  window.DealEventPipe.trigger('cartFormSubmit', ev);
};

const updateCartForm = (dealUuid, optionUuid) => {
  window.DealEventPipe.trigger('cartFormInitialize', {
    dealUuid,
    uuid: optionUuid,
  });
};

const updateAndSubmitCartForm = (dealUuid, optionUuid, ev) => {
  updateCartForm(dealUuid, optionUuid);
  submitCartForm(ev);
};

const getDealData = element => {
  const { deal: dealUuid, uuid: optionUuid } = element.dataset;

  return {
    dealUuid,
    optionUuid,
  };
};

const addCartHandler = function addCartHandler(cart, isTouch = false) {
  if (!cart || !document.querySelector('#goods-add-to-cart-form')) {
    return;
  }
  const { dealUuid } = cart;

  this.eventPipe.on('option_updated', ({ optionUuid }) => {
    updateCartForm(dealUuid, optionUuid);
  });

  if (isTouch) {
    const activeModalOptionEls = document.querySelectorAll(
      'ul.option-list li:not(.sold-out) a'
    );
    for (let i = 0; i < activeModalOptionEls.length; i++) {
      activeModalOptionEls[i].addEventListener('click', event => {
        event.preventDefault();
        const { optionUuid } = getDealData(event.currentTarget);
        updateAndSubmitCartForm(dealUuid, optionUuid, event);
      });
    }
  }
};

module.exports = { addCartHandler, updateAndSubmitCartForm };
